import { render, staticRenderFns } from "./contactPage.vue?vue&type=template&id=beca4d00&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"
import style0 from "./contactPage.vue?vue&type=style&index=0&id=beca4d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beca4d00",
  null
  
)

export default component.exports